import { useQuery } from '@tanstack/react-query'
import { R } from '@/modules/api/actions'

export const PERSONAS_QUERY_KEY = 'personas'

export function usePersonasQuery(enabled = true) {
    return useQuery({
        queryKey: [PERSONAS_QUERY_KEY],
        queryFn: async () => (await R.getAllPersonas()).personas,
        enabled,
    })
}
